module.exports = __webpack_public_path__ + "static/media/arrows-v-alt.fc261a51.svg";